import { defineStore } from "pinia";

export const useFormDataStore = defineStore({
  id: "formData",
  state: () => {
    return {
      eventName: "tff2026",
      orderInfo: {},
      donationInfoFormData: {},
      registrationInfoFormData: {},
      paymentInfoFormData: {},
      formSubmissionData: {},
      gPayToken: null,
      aPayToken: null,
      aPaySession: null,
      canadaProvinceOptions: {
        Alberta: "AB",
        "British Columbia": "BC",
        Manitoba: "MB",
        "New Brunswick": "NB",
        "Newfoundland and Labrador": "NL",
        "Northwest Territories": "NT",
        "Nova Scotia": "NS",
        Nunavut: "NU",
        Ontario: "ON",
        "Prince Edward Island": "PE",
        Quebec: "QC",
        Saskatchewan: "SK",
        "Yukon Territory": "YT",
      },
      canadaProvinceOptionsFR: {
        "L'Alberta": "AB",
        "La Colombie-Britannique": "BC",
        "Le Manitoba": "MB",
        "Le Nouveau-Brunswick": "NB",
        "La Terre-Neuve-et-Labrador": "NL",
        "Les Territoires du Nord-Ouest": "NT",
        "La Nouvelle-Écosse": "NS",
        "Le Nunavut": "NU",
        "L'Ontario": "ON",
        "Île-du-Prince-Édouard": "PE",
        "Le Québec": "QC",
        "La Saskatchewan": "SK",
        "Le Yukon le territoire du Yukon": "YT",
      },
    };
  },
  actions: {
    setOrderInfo(order) {
      this.orderInfo = order;
    },
    setDonationInfoFormData(formData) {
      this.donationInfoFormData = formData;
    },
    setRegistrationInfoFormData(formData) {
      this.registrationInfoFormData = formData;
    },
    setPaymentInfoFormData(formData) {
      this.paymentInfoFormData = formData;
    },
    setFormSubmissionData(formData) {
      this.formSubmissionData = formData;
    },
  },
  getters: {
    getRegistrationInfoFormData(state) {
      return [
        {
          title: "Full Name",
          value:
            state.registrationInfoFormData.firstName +
            " " +
            state.registrationInfoFormData.lastName,
        },
        {
          title: "Address",
          value:
            state.registrationInfoFormData.address +
            " " +
            state.registrationInfoFormData.address2,
        },
        {
          title: "Postal Code",
          value: state.registrationInfoFormData.registrationPostalCode,
        },
        {
          title: "City",
          value: state.registrationInfoFormData.city,
        },
        {
          title: "Province",
          value: state.registrationInfoFormData.province,
        },
        {
          title: "Phone Number",
          value: state.registrationInfoFormData.phone,
        },
        {
          title: "Email",
          value: state.registrationInfoFormData.email,
        },
      ];
    },
  },
});
